import {enqueueSnackbar} from 'notistack'
import {ChangeEvent, FC, useEffect, useRef, useState} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {Button} from '../../../../../../components/UI/Button'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {ModalErrorUpload} from '../../../../../central/pages/componentes/Modal/ModalErrorUpload'
import {
  getTemplateBookingSummaryService,
  getTemplateSummaryBookingService,
  uploadTemplateBookingSummaryService,
} from '../../../../services/booking.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import Poppup from '../../../../../../components/UI/Poppup'

export const getSnackBar = (message: String, variant: boolean) => {
  enqueueSnackbar(message, {
    variant: variant ? 'success' : 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}
const FormMasiveUploadResumedBooking: FC = () => {
  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState('')
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()
  const [show, setShow] = useState(false)
  const [response, setResponse] = useState('')
  const [intervalId, setIntervalId] = useState(null)
  const [progress, setProgress] = useState(0)
  const [showPoppup, setShowPoppup] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [loading, setLoading] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)
  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [intervalId])

  const incrementProgress = () => {
    setProgress((prev: any) => (prev < 90 ? prev + 1 : prev))
  }

  const handleShowDetail = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'table-details-upload-booking-summary',
      },
      noFormDetail: true,
    }
    changeCurrentTabItem(obj)
  }

  const handleGetTemplate = async () => {
    try {
      setLoadingDownload(true)
      const response = (await getTemplateSummaryBookingService()) as any
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reservas-Resumidas-Plantilla.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingDownload(false)
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setError('')
    setProgress(0)
  }

  const handleUpload = async () => {
    try {
      if (file) {
        let success = false

        setError('')
        const formData = new FormData()
        formData.append('test', file)
        const obj: TabModel = {
          ...currentTabItem,
          trayUpdated: false,
        }
        changeCurrentTabItem(obj)
        setLoading(true)
        const interval = setInterval(incrementProgress, 500)
        setIntervalId(interval as any)
        setShowPoppup(true)
        const response = await uploadTemplateBookingSummaryService(formData) // Use the service to upload the file
        success = response?.data.error

        if (!response.data.error) {
          setLoading(false)
          const obj: TabModel = {
            ...currentTabItem,
            trayUpdated: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          const obj: TabModel = {
            ...currentTabItem,
            trayUpdated: false,
          }
          changeCurrentTabItem(obj)
          const error = response?.data?.message.toString() || ''
          setResponse(error)
        }
        if (fileInputRef.current) {
          fileInputRef.current.value = '' // Borra la selección de archivo
        }
        // Iniciar el incremento final hasta 100%
        const completeInterval = setInterval(() => {
          setProgress((prev) => {
            if (prev >= 100) {
              clearInterval(completeInterval)
              setLoading(false)
              setShowPoppup(false)
              if (!success) {
                getSnackBarToast(
                  'Documento cargado correctamente, ingrese a la bandeja si tiene observaciones',
                  'success',
                )
              } else {
                setShow(true)
              }
              return prev
            }
            return prev + 1
          })
        }, 15)
        setFile(null)
      } else {
        setError('Este campo es requerido')
        console.error('No file selected.')
      }
    } catch (error) {
      setLoading(false)
      getSnackBarToast('Hubo un error', 'error')
      setShowPoppup(false)
      setProgress(0)
    }
  }

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }, [])
  return (
    <>
      <KTCard shadow className='m-5'>
        <form>
          <div className='p-6'>
            <div className='d-flex'>
              <div className='col-6'>
                <div className='mb-3 col-10'>
                  <Button
                    onClick={handleGetTemplate}
                    label='Descargar Plantilla'
                    loading={loadingDownload}
                  />
                </div>
              </div>
              <div className='col-6 row'>
                <div className='d-flex h-40px justify-content-end'>
                  <Button onClick={handleShowDetail} label='Abrir Bandeja' />
                </div>
              </div>
            </div>
            <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
              <label className='required form-label'>Examinar</label>
              <div className='input-group input-group-sm'>
                <input
                  className='form-control'
                  type='file'
                  id='formFileRoom'
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
              </div>
              {showPoppup && (
                <Poppup
                  progress={progress}
                  text={
                    'Se está cargando la información, espere un momento mientras termine de procesar ...'
                  }
                />
              )}

              {error && <p className='error-message'>{error?.toString()}</p>}
            </div>
          </div>
          <div className='d-flex justify-content-center mb-3'>
            <Button onClick={handleUpload} label='Subir Archivo' disabled={loading} />
          </div>
        </form>
        <ModalErrorUpload show={show} setShow={setShow} message={response} file={file} />
      </KTCard>
    </>
  )
}

export {FormMasiveUploadResumedBooking}
